import { observer } from 'mobx-react'
import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import { ReactComponent as LearnIcon } from './icons/learn.svg'
import { ReactComponent as LobbyIcon } from './icons/lobby.svg'
// import { ReactComponent as VideosIcon } from './icons/videos.svg'
import { ReactComponent as NftsIcon } from './icons/nfts.svg'
import { ReactComponent as OurTokenIcon } from './icons/our-tokens.svg'
import { ReactComponent as ShopIcon } from './icons/shop.svg'
import { ReactComponent as SocialsIcon } from './icons/socials.svg'

export function DashboardNav() {
  const location = useLocation()
  const isLobby = location.pathname.endsWith('lobby')

  return (
    <div className="panel--simple padded-1 margin-bottom-1">
      <nav className={`dashboard__nav ${isLobby ? 'on-lobby' : ''}`}>
        <NavLink className="dashboard__nav-item" to="/dashboard/lobby">
          <LobbyIcon className="dashboard__nav-icon" />
          <br />
          Lobby
        </NavLink>
        <NavLink className="dashboard__nav-item" to="/dashboard/our-token">
          <OurTokenIcon className="dashboard__nav-icon" />
          <br />
          Ooki Token
        </NavLink>
        <NavLink className="dashboard__nav-item" to="/dashboard/shop">
          <ShopIcon className="dashboard__nav-icon" />
          <br />
          Shop
        </NavLink>
        <NavLink className="dashboard__nav-item" to="/dashboard/nfts">
          <NftsIcon className="dashboard__nav-icon" />
          <br />
          {"NFT's"}
        </NavLink>
        <NavLink className="dashboard__nav-item" to="/dashboard/learn">
          <LearnIcon className="dashboard__nav-icon" />
          <br />
          Ookiversity
        </NavLink>
        <NavLink className="dashboard__nav-item" to="/dashboard/socials">
          <SocialsIcon className="dashboard__nav-icon" />
          <br />
          Social
        </NavLink>
        {/* <NavLink className="dashboard__nav-item" to="/dashboard/videos">
          <VideosIcon className="dashboard__nav-icon" />
          <br />
          Videos
        </NavLink> */}
      </nav>
    </div>
  )
}

export default observer(DashboardNav)
